module.exports = __webpack_public_path__ + "static/media/backWave4.d840fb57.svg";